var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCustomerLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(-.312 -.312)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 0.312,
    y: 0.312,
    fill: "#E0E0E0",
    rx: 16
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.597 4.883)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.248.224h4.933A5.818 5.818 0 0 1 18 6.042v8.182a5.818 5.818 0 0 1-5.818 5.818H7.248a5.818 5.818 0 0 1-5.819-5.818V6.042A5.818 5.818 0 0 1 7.248.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M11.911 20.259H7.518a6.312 6.312 0 0 1-6.305-6.305V6.312A6.312 6.312 0 0 1 7.518.007h4.393a6.312 6.312 0 0 1 6.305 6.305v7.642a6.312 6.312 0 0 1-6.305 6.305zM7.518.44a5.879 5.879 0 0 0-5.872 5.871v7.642a5.879 5.879 0 0 0 5.872 5.872h4.393a5.879 5.879 0 0 0 5.872-5.872V6.312A5.879 5.879 0 0 0 11.91.441H7.518z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.714 19.252A6.435 6.435 0 0 0 3.3 25.668v5.824h12.83v-5.824a6.435 6.435 0 0 0-6.416-6.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M16.13 31.708H3.299a.217.217 0 0 1-.217-.217v-5.823a6.632 6.632 0 1 1 13.264 0v5.823a.217.217 0 0 1-.216.217zm-12.615-.433h12.398v-5.607a6.199 6.199 0 1 0-12.398 0v5.607z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M3.299 25.668v5.824H16.13v-5.824a6.435 6.435 0 0 0-6.416-6.416A6.435 6.435 0 0 0 3.3 25.668z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.714 21.77a1.766 1.766 0 0 0 1.761-1.762V17.13H7.953v2.878c.003.972.79 1.758 1.761 1.761z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M9.714 21.986a1.98 1.98 0 0 1-1.977-1.978V17.13a.217.217 0 0 1 .216-.217h3.522a.217.217 0 0 1 .217.217v2.878a1.98 1.98 0 0 1-1.978 1.978zm-1.544-4.64v2.662a1.544 1.544 0 0 0 3.089 0v-2.661h-3.09z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.827,
    height: 16.212,
    x: 2.801,
    y: 2.275,
    fill: "#FFF",
    rx: 6.913
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M11.31 18.704H8.119a5.54 5.54 0 0 1-5.534-5.534V7.592a5.54 5.54 0 0 1 5.534-5.533h3.193a5.54 5.54 0 0 1 5.533 5.533v5.578a5.54 5.54 0 0 1-5.533 5.534zM8.119 2.492a5.106 5.106 0 0 0-5.1 5.1v5.578a5.106 5.106 0 0 0 5.1 5.1h3.193a5.106 5.106 0 0 0 5.1-5.1V7.592a5.106 5.106 0 0 0-5.1-5.1H8.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.649 10.369a2.157 2.157 0 0 0 2.15 2.15v-4.3a2.157 2.157 0 0 0-2.15 2.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M2.8 12.736A2.367 2.367 0 0 1 2.8 8a.217.217 0 0 1 .216.217v4.301a.216.216 0 0 1-.216.217zm-.217-4.29a1.934 1.934 0 0 0 0 3.845V8.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.63 8.218v4.302a2.15 2.15 0 0 0 0-4.302z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M16.63 12.736a.217.217 0 0 1-.218-.217V8.218a.216.216 0 0 1 .217-.217 2.367 2.367 0 0 1 0 4.735zm.216-4.29v3.845a1.934 1.934 0 0 0 0-3.845z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.63,
    cy: 10.276,
    r: 1,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.799,
    cy: 10.276,
    r: 1,
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M7.62 14.502a2.244 2.244 0 0 0 4.188 0H7.621z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.473 5.402c0 .264-.064.524-.186.759a1.669 1.669 0 0 0-1.48-.906H5.622A1.669 1.669 0 0 1 3.96 3.663c-.001-.024-.004-.048-.004-.073V1.925A1.67 1.67 0 0 1 5.62.26h8.187a1.67 1.67 0 0 1 1.665 1.665V3.59c0 .025-.003.049-.004.073.001.025.004.049.004.074v1.665z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M15.287 6.378a.217.217 0 0 1-.193-.117 1.446 1.446 0 0 0-1.286-.789H5.62a1.877 1.877 0 0 1-1.878-1.8L3.74 3.59V1.925A1.884 1.884 0 0 1 5.621.043h8.187a1.884 1.884 0 0 1 1.882 1.882V3.59l-.003.059.003.087v1.666c0 .299-.072.593-.21.859a.217.217 0 0 1-.193.117zM5.62.476c-.8.001-1.448.65-1.449 1.449V3.59l.004.064c.032.774.67 1.386 1.445 1.385h8.187a1.87 1.87 0 0 1 1.42.65c.019-.094.028-.19.028-.287V3.736l-.003-.08.22-.066h-.217V1.925c0-.8-.649-1.448-1.448-1.449H5.62z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCustomerLight);
export default __webpack_public_path__ + "static/media/default-customer-light.a02a8d6236087aa0cfa02b9f9ede82e0.svg";
export { ForwardRef as ReactComponent };